import { render, staticRenderFns } from "./ProjectBase.vue?vue&type=template&id=6f1e617c&scoped=true&"
import script from "./ProjectBase.vue?vue&type=script&lang=js&"
export * from "./ProjectBase.vue?vue&type=script&lang=js&"
import style0 from "./ProjectBase.vue?vue&type=style&index=0&id=6f1e617c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1e617c",
  null
  
)

export default component.exports